import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import { FixtureForm } from '@cds/betting-offer/add-ons';
import { EventOptionGroup, ScoreboardType } from '@frontend/sports/betting-offer/feature/model';
import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { GridEvent } from '@frontend/sports/grid/core/feature/model';

import { TeamType } from '../../statistics/statistics.models';
import { MarketGroupItem } from '../multi-builder.model';
import { MultiBuilderService } from '../multi-builder.service';

@Component({
    selector: 'ms-multi-builder-card',
    templateUrl: 'multi-builder-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MultiBuilderCardComponent implements OnChanges {
    @Input() gridEvent: GridEvent;
    @Input() selectedTab: MarketGroupItem;
    @Input() optionNames: string[];
    @Input() optionGroup: EventOptionGroup;
    @Input() statistics?: FixtureForm;

    teamType = TeamType;
    showScoreboardDetails = false;
    isScoreBoardStarted = false;
    showParticipantImage: boolean;
    scoreboardType = ScoreboardType;
    showStats = false;
    isSetGame: boolean;

    constructor(private multiBuilderService: MultiBuilderService) {}

    ngOnChanges(changes: ISimpleChanges<MultiBuilderCardComponent>): void {
        if (changes.gridEvent) {
            this.showScoreboardDetails = this.gridEvent.participants.length === 2;
            this.isScoreBoardStarted = this.gridEvent.scoreboard && this.gridEvent.scoreboard.started;
            this.isSetGame = this.gridEvent.isSetGame();
            this.showParticipantImage = this.multiBuilderService.isParticipantImageAvailable(this.gridEvent);
        }

        if (changes.statistics) {
            this.checkStatsAvailability();
        }
    }

    logoLoaded(logoLoaded: boolean): void {
        this.showParticipantImage = logoLoaded;
    }

    private checkStatsAvailability(): void {
        this.showStats = !!(this.statistics?.overallHomeTeamForm?.outcomes?.length && this.statistics?.overallAwayTeamForm?.outcomes?.length);
        if (this.showStats) {
            this.statistics!.overallAwayTeamForm!.outcomes = this.statistics!.overallAwayTeamForm!.outcomes.reverse();
        }
    }
}
